import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../../../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { getSeriesRankList } from '../../../../../../services/api';

class SeriesRank extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    state = {
        seriesRankList: [],
    };

    async componentDidMount() {
        try {
            if (this.props.content && this.props.content.serialId) {
                const seriesRankList = await getSeriesRankList(this.props.content.serialId);

                this.setState({
                    seriesRankList,
                });
            } else {
                const seriesRankList = await getSeriesRankList();

                this.setState({
                    seriesRankList,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { content } = this.props;
        const { seriesRankList } = this.state;

        return (
            <div>
                <div className={styles.arl_rs_tit}>
                    <h3>大家都在看</h3>
                </div>
                <div className={styles.arl_md_rank}>
                    <ul>
                        {seriesRankList.length > 0 &&
                            seriesRankList.slice(0, 3).map((item, index) => (
                                <li className={styles.nt} key={index}>
                                    <span className={styles.n}>{index + 1}</span>
                                    <a
                                        className={styles.img}
                                        target="_blank"
                                        rel={rel}
                                        title={item.standardName}
                                        href={
                                            content
                                                ? `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy-${
                                                      content.serialId
                                                  }`
                                                : `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`
                                        }>
                                        <img width="120" height="80" src={item.logo} alt={item.standardName} />
                                    </a>
                                    <a
                                        className={styles.name}
                                        target="_blank"
                                        rel={rel}
                                        title={item.standardName}
                                        href={
                                            content
                                                ? `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy-${
                                                      content.serialId
                                                  }`
                                                : `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`
                                        }>
                                        {item.standardName}
                                    </a>
                                    <a
                                        target="_blank"
                                        rel={rel}
                                        title={item.standardName}
                                        href={
                                            content
                                                ? `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy-${
                                                      content.serialId
                                                  }`
                                                : `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`
                                        }>
                                        <span className={styles.price}>{item.guidePrice}</span>
                                    </a>
                                </li>
                            ))}
                        {seriesRankList.length > 0 &&
                            seriesRankList.slice(3, seriesRankList.length).map((item, index) => (
                                <li key={index}>
                                    <span className={styles.n}>{index + 4}</span>
                                    <a
                                        className={styles.name}
                                        target="_blank"
                                        rel={rel}
                                        title={item.standardName}
                                        href={
                                            content
                                                ? `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy-${
                                                      content.serialId
                                                  }`
                                                : `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`
                                        }>
                                        {item.standardName}
                                    </a>
                                    <a
                                        target="_blank"
                                        rel={rel}
                                        title={item.standardName}
                                        href={
                                            content
                                                ? `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy-${
                                                      content.serialId
                                                  }`
                                                : `https://car.auto.ifeng.com/series/${item.id}/#newsLevelSerBy`
                                        }>
                                        <span className={styles.price}>{item.guidePrice}</span>
                                    </a>
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(SeriesRank);
